// Textos compartidos por toda la app (selector de idioma, botones genéricos).
export default {
  'Cambiar a {idioma}': 'Switch to {idioma}',
  'Un momento…': 'One moment…',
  'No pudimos conectarnos. Inténtalo otra vez.': "We couldn't connect. Please try again.",
} satisfies Record<string, string>;
